import { render, staticRenderFns } from "./Account.vue?vue&type=template&id=9b277a6c&scoped=true&"
import script from "./Account.vue?vue&type=script&lang=js&"
export * from "./Account.vue?vue&type=script&lang=js&"
import style0 from "./Account.vue?vue&type=style&index=0&id=9b277a6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b277a6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/admin/workspace/ss/ss-web-game/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b277a6c')) {
      api.createRecord('9b277a6c', component.options)
    } else {
      api.reload('9b277a6c', component.options)
    }
    module.hot.accept("./Account.vue?vue&type=template&id=9b277a6c&scoped=true&", function () {
      api.rerender('9b277a6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/popup/Account.vue"
export default component.exports